export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10648.6fcc3936.jpg";